// extracted by mini-css-extract-plugin
module.exports = {"containerFooterMobile":"styles_containerFooterMobile__3zUXV","containerFooterDesktop":"styles_containerFooterDesktop__28Rv4"};